import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { getConfig, update } from '../../api/config';
import { list } from '../../api/wounds';
import { Button } from '../../components/Button';
import { SpinnerBlock } from '../../components/Spinner';
import { WoundItem } from '../../components/WoundItem';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import { WoundsDetailsModal } from './WoundsDetailsModal';
import S from './wounds.styl';
var WoundsView = /** @class */ (function (_super) {
    __extends(WoundsView, _super);
    function WoundsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            wounds: [],
            loading: false,
            showCreateModal: false,
            titleError: false,
            contentError: false,
            contentState: '',
        };
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.createAction = function () {
            _this.setState({
                editWound: undefined,
                showCreateModal: true,
            });
        };
        _this.onCloseAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
        };
        _this.isUpdatedAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
            _this.fetchData();
        };
        _this.isEditClicked = function (wound) {
            _this.setState({
                editWound: wound,
                showCreateModal: true,
            });
        };
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleError: false });
            }
        };
        return _this;
    }
    WoundsView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    WoundsView.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleError: true });
            valid = false;
        }
        var html = this.contentRef.getContent();
        if (isHtmlEmpty(html)) {
            this.setState({ contentError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            chooseWoundTitle: title,
            chooseWoundContent: html,
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    WoundsView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        list().then(function (result) {
            _this.setState({
                loading: false,
                wounds: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
            });
            if (result) {
                _this.setState({
                    contentState: result.chooseWoundContent || '',
                });
            }
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    WoundsView.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var i18n = props.store.i18n;
        var _a = this.state, loading = _a.loading, wounds = _a.wounds, contentState = _a.contentState, config = _a.config;
        return (React.createElement("div", { className: S.woundsView },
            React.createElement("h1", { className: S.woundsTitle }, i18n.woundsSubTitle),
            React.createElement("hr", { className: S.woundsSeparator }),
            React.createElement("div", { className: S.woundsMainBox },
                React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.addInputWrapper },
                            React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.addInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.chooseWoundTitle })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleContent),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.contentRef = editor; }, apiKey: getEditorKey(), initialValue: contentState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentError ? 'inputErrorActive' : '') }, i18n.validationIndicationError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.addButton, type: "submit", spinner: loading }, i18n.actionUpdate))),
            React.createElement("hr", { className: S.woundsSeparator }),
            React.createElement("div", { className: S.woundsHeaderActions },
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.woundsMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.woundsHeader },
                            React.createElement("div", { className: S.tableCell + " imageCell" }, i18n.woundsItemImage),
                            React.createElement("div", { className: S.tableCell }, i18n.woundsItemTitle),
                            React.createElement("div", { className: S.action }, i18n.woundsAction)),
                        React.createElement("div", { className: S.woundsUserList }, wounds.map(function (wound, i) { return (React.createElement(WoundItem, { key: i, wound: wound, isUpdated: _this.onUpdate, isEditClicked: _this.isEditClicked })); })))),
            this.state.showCreateModal &&
                React.createElement(WoundsDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, wound: this.state.editWound })));
    };
    __decorate([
        action.bound
    ], WoundsView.prototype, "onSubmit", null);
    WoundsView = __decorate([
        inject('store'),
        observer
    ], WoundsView);
    return WoundsView;
}(React.Component));
export { WoundsView };
